import { gql } from '@apollo/client';

export const GET_LINE_ITEM_BILLABLE_THIRD_PARTIES = gql`
  query GET_LINE_ITEM_BILLABLE_THIRD_PARTIES {
    getLineItemBillableThirdPartiesV5
  }
`;
